import WORK_VUETIFY_ICON_SET from '@/components/global_components/work_icons/WORK_VUETIFY_ICON_SET';

const GLOBAL_VUETIFY_ICON_SET = Object.freeze({
  values : {
    ...WORK_VUETIFY_ICON_SET,
    // overwrite default icons used by vuetify
    // 'complete': '',
    // 'cancel': '',
    'close': WORK_VUETIFY_ICON_SET.wClose,
    'delete': WORK_VUETIFY_ICON_SET.wClose,
    'clear': WORK_VUETIFY_ICON_SET.wClose,
    'success': WORK_VUETIFY_ICON_SET.wCheck,
    'info': WORK_VUETIFY_ICON_SET.wAttention,
    'warning': WORK_VUETIFY_ICON_SET.wWarning,
    // 'error': WORK_VUETIFY_ICON_SET,
    'prev': WORK_VUETIFY_ICON_SET.wBack,
    'next': WORK_VUETIFY_ICON_SET.wNext,
    'checkboxOn': WORK_VUETIFY_ICON_SET.wCheckboxSelect,
    'checkboxOff': WORK_VUETIFY_ICON_SET.wCheckboxIndeterminate,
    'checkboxIndeterminate': WORK_VUETIFY_ICON_SET.wCheckboxIndeterminate,
    // 'delimiter': '', // for carousel
    // 'sort': WORK_VUETIFY_ICON_SET.,
    'expand': WORK_VUETIFY_ICON_SET.wArrowDown,
    // 'menu': WORK_VUETIFY_ICON_SET.wM,
    // 'subgroup': '',
    'dropdown': WORK_VUETIFY_ICON_SET.wArrowDown,
    'radioOn': WORK_VUETIFY_ICON_SET.wRadioSelected,
    'radioOff': WORK_VUETIFY_ICON_SET.wRadioUnselected,
    'edit': WORK_VUETIFY_ICON_SET.wEdit
  }
});

export default GLOBAL_VUETIFY_ICON_SET;
